import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ScheduleStop } from '../salesRepDashboardTypes';
import styles from './ScheduleCard.module.css';

interface ScheduleCardProps {
  stops: ScheduleStop[];
}

const statusLabel: Record<ScheduleStop['status'], string> = {
  completed: 'completed',
  upcoming: 'upcoming',
  pending: 'pending',
};

export const ScheduleCard: React.FC<ScheduleCardProps> = ({ stops }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Today's Schedule</h3>
        <button
          type="button"
          className={styles.viewAll}
          onClick={() => navigate('/activities')}
        >
          View All →
        </button>
      </div>
      <div className={styles.grid}>
        {stops.map((stop) => (
          <div key={stop.id} className={styles.stop}>
            <div className={styles.stopHeader}>
              <div>
                <p className={styles.stopName}>{stop.name}</p>
                <p className={styles.stopType}>📍 {stop.type}</p>
              </div>
              <span className={`${styles.statusBadge} ${styles[`status_${stop.status}`]}`}>
                {statusLabel[stop.status]}
              </span>
            </div>
            <p className={styles.time}>🕘 {stop.time}</p>
            <div className={styles.actions}>
              {stop.phone ? (
                <a href={`tel:${stop.phone}`} className={styles.callBtn}>📞 Call</a>
              ) : (
                <button type="button" className={styles.callBtn} disabled title="No phone on file">📞 Call</button>
              )}
              <button
                type="button"
                className={styles.orderBtn}
                onClick={() => stop.customerId && navigate(`/new-order?customer_id=${stop.customerId}`)}
                disabled={!stop.customerId}
              >
                + Order
              </button>
              <button
                type="button"
                className={styles.detailsBtn}
                onClick={() => stop.customerId && navigate(`/customer-details?id=${stop.customerId}`)}
                disabled={!stop.customerId}
              >
                Details &gt;
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
